import React from "react";
import $ from "jquery";
import _ from "lodash";
import Project from "./project.js";
import ProjectRow from "./project-row.js";

/**
 * A project list houses a bunch of....you got it. projects.
 */
class ProjectList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      projects: [],
    };
  }

  /**
   */
  componentDidMount() {
    const self = this;
    const request = new XMLHttpRequest();

    request.open("GET", this.buildUrl(), true);
    request.onload = function () {
      if (request.status >= 200 && request.status < 400) {
        self.setState({
          projects: _.toArray(JSON.parse(request.responseText)),
        });
      }
    };

    request.onerror = function () {
      // There was a connection error of some sort
    };

    request.send();
  }

  /**
   * Build url used to pull down projects.
   * @return string url
   */
  buildUrl() {
    let url = "/portfolio/load-projects-ajax";
    let querySeparator = "?";
    if (this.props.category) {
      url += `${querySeparator}c=${this.props.category}`;
      querySeparator = "&";
    }

    url += `${querySeparator}p=${this.getPage()}`;
    return url;
  }

  /**
   * @return {array.<ProjectRow>}
   */
  createProjectRows() {
    if (!this.state.projects.length) {
      return <div className="loader">loading...</div>;
    }

    const odd = [];
    const even = [];

    const self = this;
    this.state.projects.forEach((project, index) => {
      if (index % 2 == 0) {
        even.push(project);
      } else {
        odd.push(project);
      }
    });

    return even.map(function (project, index) {
      const projects = [project];
      const projectGroup = "a";

      if (odd[index]) {
        projects.push(odd[index]);
      }
      return (
        <ProjectRow
          key={`prowkey${project.id}`}
          projects={projects}
          group={this.getProjectGroup(index)}
          category={this.props.category}
        />
      );
    }, this);
  }

  /**
   * 2 group types, each group block has 4 projects.
   * @param  {number} index - row index
   * @return {string}
   */
  getProjectGroup(index) {
    if (index % 2 > 0) {
      return "b";
    }
    return "a";
  }

  /**
   * Returns page based on hidden input value. If not present, defaults to 1.
   * @return {number}
   */
  getPage() {
    const $pageNumber = $(".pagination").find('[name="current-page"]');
    if ($pageNumber.length) {
      return $pageNumber.val();
    }
    return 1;
  }

  /**
   */
  render() {
    return <div>{this.createProjectRows()}</div>;
  }
}

export default ProjectList;
